import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";

export default function MaterialsLayout() {
  const { title, base, sections } = projectMenus.materials;

  return (
    <SidebarLayout
      title={title}
      base={base}
      sections={sections}
    >
      <Outlet />
    </SidebarLayout>
  );
}
